import { DeviceMobileIcon } from "@heroicons/react/outline";
import { SearchIcon, ShoppingCartIcon } from "@heroicons/react/solid";

function Header() {
  return (
    <header className=" bg-white w-full shadow-md pb-3 sticky top-0 z-50">
      {/* top */}
      <div className="bg-gray-100 px-12 p-2 items-center justify-between hidden lg:flex">
        <div className="flex items-center space-x-1">
          <DeviceMobileIcon className="h-5 text-gray-600" />
          <p className="link">Download Tokopedia App</p>
        </div>
        <div className="flex items-center space-x-8">
          <p className="link">Tentang Tokopedia</p>
          <p className="link">Mitra Tokopedia</p>
          <p className="link">Mulai Berjualan</p>
          <p className="link">Promo</p>
          <p className="link">Tokopedia Care</p>
        </div>
      </div>
      {/* middle */}
      <div className=" lg:px-12 p-2 my-2 flex items-center space-x-6 relative">
        <img
          className="cursor-pointer hidden lg:block"
          src="https://ecs7.tokopedia.net/assets-tokopedia-lite/v2/zeus/production/e5b8438b.svg"
          alt=""
        />
        <p className="link hover:bg-gray-100 p-2 rounded-md hidden lg:inline">
          Kategori
        </p>
        {/* <div className="bg-white hidden absolute top-20 -left-6 w-full max-h-[496px] border-t mt-1 pl-12">
          <div className="flex items-center space-x-6 overflow-x-scroll p-3 whitespace-nowrap">
            <h1 className="nav-link border-b border-tokped_green text-tokped_green">
              Belanja
            </h1>
            <h1 className="nav-link">Featured</h1>
            <h1 className="nav-link">Brand Unggulan</h1>
            <h1 className="nav-link">Halal Corner</h1>
            <h1 className="nav-link">Investasi Asuransi & Pinjaman</h1>
            <h1 className="nav-link">Pajak</h1>
            <h1 className="nav-link">Pendidikan</h1>
            <h1 className="nav-link">Tagihan</h1>
            <h1 className="nav-link">Top-Up</h1>
            <h1 className="nav-link">Travel & Entertainment</h1>
            <h1 className="nav-link">Lainnya</h1>
          </div>
          <div className="flex">
            <div className="flex flex-col overflow-y-scroll p-2 w-48">
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
              <h1 className="link-drop">Buku</h1>
            </div>
            <div className="p-5">
              <h1>Buku</h1>
            </div>
          </div>
        </div>
         */}
        <div className="flex-grow flex items-center bg-gray-100 h-8 border rounded-md text-xs text-gray-400 focus-within:border-tokped_green">
          <input
            className="flex-grow w-full h-full focus:outline-none px-3 rounded-l-md"
            placeholder="Cari samsung galaxy A6"
            type="text"
          />
          <SearchIcon className="h-8 p-2 text-gray-500 cursor-pointer" />
        </div>
        <ShoppingCartIcon className="h-8 text-gray-500 cursor-pointer lg:p-1 hover:bg-gray-100 rounded-md" />
        <div className="h-7 border" />
        <div className="flex space-x-2">
          <button className="font-bold text-tokped_green px-3 py-1 border border-tokped_green rounded-md text-sm">
            Masuk
          </button>
          <button className="font-bold text-white bg-tokped_green px-3 py-1 rounded-md">
            Daftar
          </button>
        </div>
      </div>
      {/* bottom */}
      <div className="flex items-center px-80 -ml-5 space-x-3 -mt-1">
        <p className="link text-sm truncate w-24">Samsung Galaxy s10</p>
        <p className="link text-sm truncate w-24">Kulkas 2 pintu okkkk</p>
        <p className="link text-sm truncate w-24">Kaos pria distro</p>
        <p className="link text-sm truncate w-24">Celana pendek pria</p>
      </div>
    </header>
  );
}

export default Header;
